<template>
  <div>
    <div>
      <v-btn class="primary" @click="close_council_dialog()">
        <v-icon>mdi-close</v-icon> Закрыть
      </v-btn>
    </div>

    <v-card v-if="(GETTERS_COUNCIL_ALL !== null) && (GETTERS_COUNCIL_ALL !== undefined)" class="main-card">
      <v-card-title text-color="#15336d">
        <v-icon left color="#15336d">mdi-label</v-icon>
        {{GETTERS_COUNCIL_ALL.name}} от {{ GETTERS_COUNCIL_ALL.date }}
        Сессия : "{{ session_name }}" С {{ calendar_start ? calendar_start.split('-').reverse().join('.') : '-' }} По {{ calendar_end ? calendar_end.split('-').reverse().join('.') : '-' }}

      </v-card-title>

      <div class="d-flex flex-nowrap justify-space-between">
        <div style="width:95%;">
          <v-card-text style="margin-bottom: 15px; margin-left: 15px;">

  <!-- PROPOSALS           -->
            <v-row>
              <v-card width="100%" style="margin:10px;">
                <v-list subheader>
                  <v-subheader>
                    <b>
                      <v-icon>mdi-attachment</v-icon>Заявки
                    </b>
                  </v-subheader>

                  <v-card-text>
                    <v-tabs-items>
                      <v-data-table
                        :style="{color: $mainColor}"
                        :headers="current_headers"
                        :items="GETTERS_COUNCIL_ALL.status > 2 ? (showReject? reject_proposals : current_proposals) : all_proposals"
                        :loading-text="$t('User.loading_orders')"
                      >
                        <template v-slot:top>
                          <v-container class="pa-0" v-if="station_id > 0">
                            <v-row>
                              <v-col cols="4" class="pt-0 pb-0 mt-3" v-if="GETTERS_COUNCIL_ALL.status > 2">
                                <v-btn
                                    v-if="showReject"
                                    text
                                    small
                                    target='_blank'
                                    @click="showReject = false"
                                    color="#16336e">
                                    <v-icon>mdi-chevron-up</v-icon>показать принятые<v-icon>mdi-chevron-up</v-icon>
                                </v-btn>
                                <v-btn
                                    v-else
                                    text
                                    small
                                    target='_blank'
                                    @click="showReject = true"
                                    color="#16336e">
                                    <v-icon>mdi-chevron-down</v-icon>показать отклоненные<v-icon>mdi-chevron-down</v-icon>
                                </v-btn>
                              </v-col>
                              <v-col cols="2" class="pt-0 pb-0">
                                <v-text-field
                                  v-model="station_time_available"
                                  label="Всего доступно (ч)"
                                  readonly
                                ></v-text-field>
                              </v-col>
                              <v-col cols="2" class="pt-0 pb-0">
                                <v-text-field
                                  v-model="station_time_provided"
                                  label="Принято (ч)"
                                  readonly
                                ></v-text-field>
                              </v-col>
                              <v-col cols="2" class="pt-0 pb-0">
                                <v-text-field
                                  v-model="station_time_rejected"
                                  label="Отклонено (ч)"
                                  readonly
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </template>

                        <template v-slot:item.proposal_id="{ item }">
                            <span @click="open_proposal_card(item.proposal_id)" style="cursor: pointer;">
                              <b>{{ item.proposal_id }}</b> {{ item.proposal.name }} <i style="font-style: italic; color: #9f00ff; font-size: 12px;"> от {{ item.proposal.date_income }} </i>
                              <br>
                              <i style="font-style: italic;">{{ item.proposal.keywords }}</i>
                            </span>
                        </template>
                        <template v-slot:item.applicant="{ item }">
                            <span @click="open_proposal_card(item.proposal_id)" style="cursor: pointer;">
                              <b>{{ item.proposal.applicant.individual.last_name }} {{ item.proposal.applicant.individual.first_name }} {{ item.proposal.applicant.individual.middle_name }}</b>
                              <br>
                              <i style="font-style: italic;">{{ item.proposal.applicant.individual.organization }}</i>
                            </span>
                        </template>
                        <template v-slot:item.provided_experiment_duration="{ item }" v-if="GETTERS_COUNCIL_ALL.status == 1 || GETTERS_COUNCIL_ALL.status == 2">
                            {{ item.proposal.experiment_duration }}
                        </template>
                        <template v-slot:item.provided_experiment_duration="{ item }" v-if="GETTERS_COUNCIL_ALL.status == 3 || GETTERS_COUNCIL_ALL.status == 5">
                            <div v-if="item.status == 1">
                              {{ item.provided_experiment_duration ? item.provided_experiment_duration : 'не отпределено' }}
                            </div>
                            <div v-else>
                              отклонена
                            </div>
                        </template>

                        <template v-slot:item.calendars="{ item }" v-if="GETTERS_COUNCIL_ALL.status == 5 || GETTERS_COUNCIL_ALL.status == 3">
                          <div v-if="item.status == 1">
                            <v-row>
                              <div class="date-interval d-flex align-center justify-space-between" v-for="(jtem, i) in full_station_events" :key="i">
                                <div v-if="jtem.source.proposal_id == item.proposal_id">
                                  {{formate_datetimeinterval(jtem)}}
                                  <v-icon
                                    v-if="item.proposal.last_status_id == 4 || item.proposal.last_status_id == 7 || item.proposal.last_status_id == 5"
                                    @click="deleteDateInterval(jtem.id, item.proposal_id)"
                                    small
                                    style="margin-left:5px;
                                    cursor:pointer;"
                                    :disabled="delete_loaded"
                                    left
                                  >
                                    mdi-close-circle-outline
                                  </v-icon>
                                </div>
                              </div>
                            </v-row>
                            <v-row>
                              <set-date-intervals
                                @updateParent="update_parent($event)"
                                :proposal_id="item.proposal_id"
                                :station_id="station_id"
                                :can_edit="true"
                                :input_dates ="null"
                                :interval_multiple="false"
                                :availiable_limit="((item.provided_experiment_duration ? parseInt(item.provided_experiment_duration) : 720) - (reserved_times[item.proposal_id] ? reserved_times[item.proposal_id] : 0))"
                                :calendar_id="0"
                                :add_new="true"
                                :small_view="true"
                                :calendar_type="GETTERS_COUNCIL_ALL.status == 5 ? 5 : 2"
                                :calendar_start="calendar_start"
                                :calendar_end="calendar_end"
                              />
                            </v-row>
                          </div>
                          <div v-else>
                            {{ item.comment }}
                          </div>
                        </template>
                      </v-data-table>
                    </v-tabs-items>
                  </v-card-text>

                </v-list>
              </v-card>
            </v-row>

          </v-card-text>
        </div>

      </div>

    </v-card>

    <v-dialog v-model="show_comment_dialog" max-width="40%">
      <v-card>
        <v-card-title class="headline">Комментарий эксперта
        </v-card-title>
        <v-card-text>{{ show_comment_dialog_text }}
        </v-card-text>


        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="show_comment_dialog = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>

import { mapActions, mapGetters, mapMutations } from "vuex";
import setDateIntervals from "../Proposals/setDateIntervals.vue";

export default {
  name: "councilModalCard",
  components: {
    setDateIntervals,
  },
  props: {
    comment: String,
    station_id: Number,
  },
  data() {
    return {
      current_headers: [],

      modal_loaded: false,
      experiment_duration: '',
      modal_action: '',
      search_email: '',

      show_comment_dialog: false,
      show_comment_dialog_text: '',
      add_proposal_dialog: false,
      add_proposal_list: [],
      availiable_proposals: [],

      add_expert_dialog: false,
      current_proposal_council_id: null,

      menu_time: false,
      edit_time_mode: false,

      my_id: -1,

      all_proposals: [],
      current_proposals: [],
      reject_proposals: [],
      station_time_available: 0,
      station_time_provided: 0,
      station_time_rejected: 0,

      full_station_events: [],
      reserved_times: {},
      delete_loaded: false,

      calendar_end: null,
      calendar_start: null,
      station: null,
      session_name: '',

      call_id: null,
      showReject: false,
    };
  },
  beforeMount() {
    this.my_id = localStorage.isLoggedIn

    this.reload_headers();

    this.cut_proposals();
    this.prepare_data()
  },

  computed: {
    ...mapGetters([
      'GETTERS_COUNCIL_ALL',
      'GETTERS_STATION_CALENDAR',
      'GETTERS_STATION_BY_ID',
      'GETTERS_NEED_RELOAD_CALENDAR',
      'GETTERS_NEED_RELOAD_CLOSE_PROPOSAL',
    ]),

  },

  methods:  {
    ...mapActions([
      'GET_COUNCIL_ALL',
      'GET_CALENDAR_LIST',
      'DELETE_CALENDAR_REC',
      'UPDATE_PROPOSAL_CALENDAR',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
      'SHOW_PROPOSAL_CARD',
    ]),


    update_parent(item) {
      this.load_calendar()
      this.UPDATE_PROPOSAL_CALENDAR(true)
      // this.$emit('updateParent')
    },

    cut_proposals(){
      this.all_proposals = []
      this.GETTERS_COUNCIL_ALL.proposals_council.forEach(item => {
        if(item.proposal.station_id == this.station_id)
          this.all_proposals.push(item)
      })
    },

    allowedStep: m => m % 30 === 0,

    deleteDateInterval(interval_id, proposal_id) {
      var args = {
        id: interval_id,
        proposal_id: proposal_id
      }
      this.delete_loaded = true
      this.DELETE_CALENDAR_REC(args)
      .then(res => {
        this.load_calendar()
        this.delete_loaded = false
      })
      .catch(() => {
          this.delete_loaded = false
      })
    },


    expert_res(exp, type) {
      if(type == 'mdi'){
        if(exp.approve_type == 0)
          return 'mdi-help-circle-outline'
        else if(exp.approve_type == 2)
          return 'mdi-check-circle-outline'
        else
          return 'mdi-close-circle-outline'
      }
      else if(type == 1){
        if(exp.approve_type == 0)
          return '#bbbbbb'
        else if(exp.approve_type == 2)
          return '#75c210'
        else
          return '#e00505'
      }
      else{
        if(exp.approve_type == 0)
          return 'нет решения'
        else if(exp.approve_type == 2)
          return 'подтвердил'
        else
          return 'отклонил'
      }
    },

    open_proposal_card(id) {
      this.call_id = new Date()
          this.SHOW_PROPOSAL_CARD({
              'proposal_id' : id,
              'call_id': this.call_id
          })
      },

    reload_council(){
      this.UPDATE_OVERLAY(true)
      this.GET_COUNCIL_ALL(this.GETTERS_COUNCIL_ALL.id)
      .then(() => {
        this.load_calendar()
        this.UPDATE_OVERLAY(false)
      })
    },

    reload_headers(){
      if(this.GETTERS_COUNCIL_ALL.status == 1 || this.GETTERS_COUNCIL_ALL.status == 2){
        this.current_headers = [
          { text: 'Заявка', sortable: true, value: 'proposal_id'},
          { text: 'Заявитель', sortable: true, value: 'applicant'},
          { text: 'Запрошенное пучковое время (ч)', sortable: true, value: 'provided_experiment_duration'},
        ]
      }
      else if(this.GETTERS_COUNCIL_ALL.status == 5){
        this.current_headers = [
          { text: 'Заявка', sortable: true, value: 'proposal_id'},
          { text: 'Заявитель', sortable: true, value: 'applicant'},
          { text: 'Выделенное пучковое время (ч)', sortable: true, value: 'provided_experiment_duration'},
          { text: 'Предварительный календарь', sortable: false, value: 'calendars', width: '350px'},
        ]
      }
      else{
        this.current_headers = [
          { text: 'Заявка', sortable: true, value: 'proposal_id'},
          { text: 'Заявитель', sortable: true, value: 'applicant'},
          { text: 'Выделенное пучковое время (ч)', sortable: true, value: 'provided_experiment_duration'},
          { text: 'Календарь', sortable: false, value: 'calendars', width: '350px'},
        ]
      }
    },

    show_comment(text){
      this.show_comment_dialog_text = text
      this.show_comment_dialog = true
    },

    formate_datetimeinterval(item){
      var date_obj_1 = new Date(item.source.start_date)
      var date_obj_2 = new Date(item.source.finish_date)
      var diff = (date_obj_2 - date_obj_1) / 3600000

      return this.formate_datetime(date_obj_1) + ' : ' + this.formate_datetime(date_obj_2) + ' (' + diff.toFixed(1) + ' ч.)'
    },

    formate_datetime(str){
      var date_obj = new Date(str)
      var month = date_obj.getMonth() + 1
      var date = date_obj.getDate()
      var m = date_obj.getMinutes()
      var h = date_obj.getHours()
      if (h<10) h = '0'+h
      if (m<10) m = '0'+m
      if (month<10) month = '0' + month
      if (date<10) date = '0' + date

      return date + '.' + month + '.' + date_obj.getFullYear() + ' ' + h + ':' + m
    },

    council_status(id){
      if(id == 1)
        return 'Принять'
      else if(id == 2)
        return 'Отклонить'
      else if(id == 3)
        return 'На доработку'
      else if(id == 4)
        return 'Рассмотреть позднее'
      else
        return 'Не определено'
    },

    close_council_dialog(){
      this.$emit('closeCouncilDialog');
    },

    prepare_data(){
      this.update_events()
      this.station_time_provided = 0
      this.station_time_rejected = 0
      this.station_time_available = 0

      this.station = this.GETTERS_STATION_BY_ID(this.station_id)
      if(this.station){
        if(this.station.megascience_type == 'synchrotron'){
          this.calendar_end = this.GETTERS_COUNCIL_ALL.si_session_end
          this.calendar_start = this.GETTERS_COUNCIL_ALL.si_session_start
          this.session_name = this.GETTERS_COUNCIL_ALL.si_session_name
        }
        else if(this.station.megascience_type == 'reactor'){
          this.calendar_end = this.GETTERS_COUNCIL_ALL.ir8_session_end
          this.calendar_start = this.GETTERS_COUNCIL_ALL.ir8_session_start
          this.session_name = this.GETTERS_COUNCIL_ALL.ir8_session_name
        }
        else if(this.station.megascience_type == 'lab'){
          this.calendar_end = this.GETTERS_COUNCIL_ALL.lab_session_end
          this.calendar_start = this.GETTERS_COUNCIL_ALL.lab_session_start
          this.session_name = this.GETTERS_COUNCIL_ALL.lab_session_name
        }
      }

      this.current_proposals = []
      this.reject_proposals = []
      this.all_proposals.forEach(item => {
        if(item.status == 1){
          this.current_proposals.push(item)
          this.station_time_provided = this.station_time_provided + parseInt(item.provided_experiment_duration)
        }
        else if(item.status == 2){
          this.reject_proposals.push(item)
          this.station_time_rejected = this.station_time_rejected + parseInt(item.proposal.experiment_duration)
        }
        else{
          this.reject_proposals.push(item)
        }
      })

      this.GETTERS_COUNCIL_ALL.council_stations.forEach(item => {
        if(item.station_id == this.station_id){
          this.station_time_available = item.available_time
        }
      })


    },

    async load_calendar(){
      if(this.station_id > 0){
        this.GET_CALENDAR_LIST({station_id:this.station_id})
        .then(() => {
          this.update_events();
        })
      }
    },

    update_events(){
      if(this.station_id > 0){
        var res = this.GETTERS_STATION_CALENDAR(this.station_id);
        if(!res){
          setTimeout(() => {
              this.update_events()
          }, 1000)
        }
        else{
          if(res.loaded){
            this.full_station_events = []
            this.reserved_times = {}
            var start_date = null, end_date = null, diff = 0

            res.calendars.forEach(calendar_item => {
              var name = ''
              if(calendar_item.type == 2 || calendar_item.type == 5){
                name = calendar_item.proposal_id + ' ' + calendar_item.proposal_applicant
              }
              else{
                name = calendar_item.experiment_name ??  'без названия'
              }

              this.full_station_events.push({
                name:  name ,
                start: this.formate_date_for_cal(calendar_item.start_date, true),
                end: this.formate_date_for_cal(calendar_item.finish_date, false),
                source: calendar_item,
                id: calendar_item.id,
                type: calendar_item.type,
              })

              if(calendar_item.type == 2 || calendar_item.type == 5){
                if(!this.reserved_times[calendar_item.proposal_id])
                  this.reserved_times[calendar_item.proposal_id] = 0

                start_date = new Date(calendar_item.start_date);
                end_date = new Date(calendar_item.finish_date);
                diff = (end_date - start_date)/ 3600000;
                this.reserved_times[calendar_item.proposal_id] += diff;

              }
            })
          }
          else{
            this.load_calendar()
          }

        }
      }
    },

    formate_date_for_cal(str, with_one){
      var dd_cal = new Date(str)
      var min = dd_cal.getMinutes()
      if (min === 0 && with_one) min = '1'
      const formatted = `${dd_cal.getFullYear()}-${(dd_cal.getMonth()+1)}-${dd_cal.getDate()} ${dd_cal.getHours()}:${min}`
      return formatted
    },


    _updateText: (str) => str.replace(/\n/g, '\u003cbr\u003e'),

  },

  watch:{
    GETTERS_COUNCIL_ALL(val) {
      this.reload_headers()
      this.cut_proposals()
      this.prepare_data()
    },

    GETTERS_NEED_RELOAD_CLOSE_PROPOSAL(val){
      if(val && val == this.call_id){
        this.reload_council()
      }
    },

    GETTERS_NEED_RELOAD_CALENDAR(val){
      if(val){
        this.load_calendar()
      }
    },
  },
};
</script>

<style scoped>
.main-card {
  background-color: #f4f5f7 !important;
  border-radius: 2px;
}
.my-green{
  color:#62ba02 !important;
}
.main-card * {
  color: #15336d;
}
.comment-expert,
.comment-bs {
  max-height: 40vh;
  overflow-y: auto;
  padding: 10px;
  padding-bottom: 15px;
}
.comment-expert {
  padding-top: 0;
}
.comment-bs *{
  color: #15336d !important;
}
.my-primary{
  color: #15336d !important;
}
.modal-mul-select{
    padding-top: 0px;
    padding-right: 24px;
    padding-bottom: 20px;
    padding-left: 24px;
}
.vertical-header-cell{
  transform:rotate(-40deg);
    /* writing-mode: vertical-lr;  */
     /* text-orientation: upright;  */
}
  .input-container__search-user,
  .input-container__search-result {
      max-width: auto;
      width: 100%;
  }
  .input-container__search-user {
    min-width: 300px;
  }

</style>
